import React from 'react';
import TabbedSection from '../components/TabbedSection';

import ApiAccessDashboard from './ApiAccess/ApiAccessDashboard';
import ApiAccessList from './ApiAccess/ApiAccessList';

const TABS = [
    { key: 'dashboard', label: 'Dashboard', Component: ApiAccessDashboard },
    { key: 'list', label: 'API Access List', Component: ApiAccessList },
];

const ApiAccessSection = () => (
    <TabbedSection title="API Access" basePath="/api-access-section" tabs={TABS} />
);

export default ApiAccessSection;
